import { Application } from '../../utilities/applications';
import { AdvancedCobranding } from '../../utilities/cobranding/cobranding';

export type AdvancedCobrandedPage = {
  application: Application;
  cobranding: AdvancedCobranding;
  Component: React.LazyExoticComponent<() => JSX.Element>;
  onFail?: () => Promise<void>;
  owner: string;
  slackChannel: string;
  /**
   * Links to external testing/monitoring tools for the cobranded page. We recommend building a
   * pollinator and adding the link to this array in your config.
   *
   * See this doc for details:
   * https://hello.atlassian.net/wiki/x/JvkGAwE
   */
  monitoringUrls: string[];
};
